"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = void 0;
const react_1 = require("react");
const generateMediaQuery_1 = require("./generateMediaQuery");
const MediaQueryCache_1 = require("./MediaQueryCache");
const useMediaQuery = (breakpoint, options = {}) => {
    const cacheKey = `${breakpoint}_${JSON.stringify(options)}`;
    let mediaQuery = MediaQueryCache_1.MediaQueryCache.get(cacheKey);
    if (!mediaQuery) {
        const mediaQueryString = (0, generateMediaQuery_1.generateMediaQuery)(breakpoint, options);
        // for SSR apps
        if (typeof window === 'undefined') {
            mediaQuery = {
                matches: false,
                media: mediaQueryString,
            };
        }
        else {
            mediaQuery = window.matchMedia(mediaQueryString);
        }
        MediaQueryCache_1.MediaQueryCache.set(cacheKey, mediaQuery);
    }
    const [isMediaQueryMatching, setIsMediaQueryMatching] = (0, react_1.useState)(mediaQuery.matches);
    (0, react_1.useEffect)(() => {
        const handler = (event) => setIsMediaQueryMatching(event.matches);
        mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addListener(handler);
        return () => mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeListener(handler);
    }, [mediaQuery]);
    return isMediaQueryMatching;
};
exports.useMediaQuery = useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map